import React from "react";
import Loading from "../";

import { Container } from "./styles";

const LoadingContainer = ({ show }) => {
  return (
    <Container show={show}>
      <Loading />
    </Container>
  );
};

export default LoadingContainer;
